import { render, staticRenderFns } from "./taxi.vue?vue&type=template&id=767ba012&scoped=true"
import script from "./taxi.vue?vue&type=script&lang=js"
export * from "./taxi.vue?vue&type=script&lang=js"
import style0 from "./taxi.vue?vue&type=style&index=0&id=767ba012&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ba012",
  null
  
)

export default component.exports